import React from 'react';
import video from '../../assets/video-make-money.mp4';
function MakeMoney() {

  return (
    <>
      <h2 className="text-4xl font-bold mb-10 text-center">How do I make money?</h2>
      
      <div className="flex justify-center mt-2">
        <video
          src={video}
          playsInline
          autoPlay
          muted
          loop
          className="max-h-[65vh] max-w-[80vw] object-contain"
        />
      </div>
    </>
  );
}

export default MakeMoney;

